// src/pages/SignIn/SignIn.tsx
import React from 'react';
import { Box } from '@mui/material';
import SignInForm from '../../components/SignInForm/SignInForm';

const SignIn: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 'calc(100vh - 120px)',
        p: 2.5,
      }}
    >
      <SignInForm />
    </Box>
  );
};

export default SignIn;
